import { makeStyles, Theme } from "@material-ui/core/styles";

interface Props {
  isLaptop: boolean;
  isBigScreen: boolean;
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
  containerFilters: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  filterItem: {
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  extraItem: {
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
